import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./application-menu.style";
import { SelectApplicationMode } from "hooks/select-application";
import { ApplicationSelect } from "ui/components/elements/application-select/application-select";
import { useOnConfirmApplication } from "hooks/use-on-confirm-application";
export var ApplicationMenu = function () {
    var onSelectApplication = useOnConfirmApplication({
        modeWithChanges: SelectApplicationMode.RESET_OR_KEEP,
        modeWithoutChanges: SelectApplicationMode.KEEP_WITHOUT_ASKING,
        confirmationModalHeaderTranslationKey: "reset_modal.restart_title",
        confirmationModalMessageTranslationKey: "reset_modal.restart_message",
    });
    return (_jsx(Styled.SelectApplication, { children: _jsx(ApplicationSelect, { onSelectApplication: onSelectApplication }) }));
};
